import axios from 'axios';
import ExpressionsDetectionModel from '../../models/ExpressionsDetectionModel';
import apiService from '../apiService';

export default async function getExpressionDetections(
  eventId = '',
  system = '',
  searchString = '',
  pagination = {
    limit: 1,
    offset: 0,
    hasMore: true,
  },
  orderBy = 'created_at',
  order = 'ASC',
) {
  try {
    let _return = {
      data: [],
      count: 0,
      pagination: pagination
    }

    const _ret = await axios({
      url: `${apiService.getUrl().faceRecognition}expressionDetection/getExpressionDetections?eventId=${eventId}&system=${system}&offset=${pagination.offset}&limit=${pagination.limit}&search=${searchString}&orderBy=${orderBy}&order=${order}`,
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      },
    });

    if (!_ret.data.success) {
      throw new Error(_ret.data.message);
    }

    _ret.data?.data?.data?.forEach(item => {
      _return.data.push(ExpressionsDetectionModel({
        id: item.id,
        macAddress: item.macAddress,
        eventId: item.eventId,
        system: item.system,
        amount: item.amount,
        neutral: item.neutral,
        happy: item.happy,
        sad: item.sad,
        angry: item.angry,
        fearful: item.fearful,
        disgusted: item.disgusted,
        surprised: item.surprised,
      }));
    });

    _return.count = _ret.data?.data?.count;

    _return.pagination = {
      limit: pagination.limit,
      offset: pagination.limit + pagination.offset,
      hasMore: _return.data.length < pagination.limit ? false : true
    };
    return _return;
  } catch (error) {
    console.log('Error getExpressionDetections', error);
    throw error;
  }
}
